export default __webpack_public_path__ + "static/media/seo-exam-dgtd-bk.81e8d625.png";